import { Component } from '@angular/core';
import { ContactType } from '../shared/contact-type.model';
import { ContactTypeService } from '../shared/contact-type.service';
import { DatagridService, UtilService } from '../../../shared/index';
import { ContactTypeSearchParams } from './contact-type-search-params.model';

@Component({
  selector: 'wl-contact-type-search',
  templateUrl: 'contact-type-search.component.html',
  styleUrls: ['contact-type-search.component.css'],
  providers: [ContactTypeService],
    standalone: false
})
export class ContactTypeSearchComponent {
  public searchResult: any;
  public searchParams: ContactTypeSearchParams;

  public loadingContactTypes: boolean;
  public loadingContactTypesError: string;

  public contactTypes: Array<ContactType>;
  public selectedContactType: ContactType;

  public constructor(
    public _contactTypeService: ContactTypeService,
    public _dataGridService: DatagridService,
    public _utilService: UtilService
  ) {
    this.searchResult = {};
    this.searchParams = new ContactTypeSearchParams();

    this.loadingContactTypes = true;
    this.loadingContactTypesError = '';

    this.contactTypes = new Array<ContactType>();
    this.selectedContactType = null;
  }

  public lazyLoadContactTypes = ($event: any): void => {
    this._dataGridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    this.loadContactTypes();
  };

  public loadContactTypes() {
    this.loadingContactTypes = true;
    this.loadingContactTypesError = '';

    this._contactTypeService
      .getContactTypes(this.searchParams)
      .then((data: any) => {
        this.loadingContactTypes = false;
        this.contactTypes = data.Result;
        this.searchResult = data;
        if (this.contactTypes.length > 0) {
          this.selectedContactType = this.contactTypes[0];
        }
      })
      .catch(error => {
        this.loadingContactTypes = false;
        this.loadingContactTypesError = this._utilService.extractErrorMessage(error);
      });
  }
}
